"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValueMapperNode = void 0;
const BaseNode_1 = require("../../BaseNode");
const Schema = __importStar(require("./schema.json"));
const NODE_TYPE = 'VALUE-MAPPER';
class ValueMapperNode extends BaseNode_1.BaseNode {
    constructor() {
        super(...arguments);
        this._resolve = (params) => {
            let outVal = undefined;
            const { source, fallback } = params;
            // now try to find any mappings that might apply
            const applicableMapping = this.config && this.config.mappings && this.config.mappings.find((mapping) => mapping[0] === source);
            if (applicableMapping) {
                outVal = applicableMapping[1];
            }
            else {
                outVal = fallback || (source && source.toString()) || undefined;
            }
            return {
                [`output`]: outVal,
            };
        };
        //TODO: Build the interface definition from the given schema....but what is our schema
        this._interfaceDefinition = Schema;
    }
}
exports.ValueMapperNode = ValueMapperNode;
ValueMapperNode._nodeDefinition = {
    NODE_TYPE,
    defaultTitle: 'Value Mapper',
    isIdempotent: true,
    primaryCategory: 'Data Lookup',
};
//# sourceMappingURL=ValueMapper.js.map